/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - CSS-in-JS</h2>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="https://css-live.ru/articles/vsyo-chto-vam-nuzhno-znat-o-css-in-js.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Всё, что вам нужно знать о CSS-in-JS
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://www.styled-components.com/" rel="noopener noreferrer" target="_blank">
          Документация Styled Components
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://emotion.sh/" target="_blank" rel="noopener noreferrer">
          Документация Emotion
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://cssinjs.org" target="_blank" rel="noopener noreferrer">
          Документация JSS
        </a>
      </li>
    </ul>
  </section>
))
